import { render, staticRenderFns } from "./bought.vue?vue&type=template&id=2ffde470&scoped=true&"
import script from "./bought.vue?vue&type=script&lang=js&"
export * from "./bought.vue?vue&type=script&lang=js&"
import style0 from "./bought.vue?vue&type=style&index=0&id=2ffde470&lang=scss&scoped=true&"
import style1 from "./bought.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffde470",
  null
  
)

export default component.exports